// @flow
import React from "react";

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import CurrentRequestOperations from "../../../Store/Ducks/CurrentRequest/operations";
import CrossCancel from "../../CrossCancel/CrossCancel";


const CancelSearch = (props) => {
    return (
        <CrossCancel onCrossClick={props.onCancelButtonClick}/>
    );
};

const mapStateToProps = (state, props) => {
    return {};
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onCancelButtonClick: CurrentRequestOperations.cancelSearchClick
        },
        dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(CancelSearch);



// WEBPACK FOOTER //
// ./src/Components/TopBar/CancelSearch/CancelSearch.js